import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SelectOption } from './_models/selectOption';
import { SelectOptionGroup } from './_models/selectOptionGroup';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'select-component', templateUrl: './select.component.html', styleUrls: ['./select.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelectComponent {
    @Input() isDisabled: boolean = false;
    @Input() control: FormControl = new FormControl();
    @Input() label: string = '';
    @Input() placeholder: string = 'elemento.generico-select.selecione';
    @Input() options: SelectOption[] = null;
    @Input() optionsGroups: SelectOptionGroup[] = null;
    @Input() isMultiselect: boolean = false;
}
